// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Migration_PreflightAssinaturaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de GET /migration/assinaturas/preflight.
 *
 * `por_tipo` e o que a tela mostra ao lado da tabela: quantas linhas cada
 * lista tem na origem, antes de qualquer carga.
 *
 * Cuidado ao ler `por_tipo['hooks']`: ele NAO e o total de webhooks da base
 * (1.209 na rede). E quantos deles pertencem a ESTA franquia — os que citam
 * uma assinatura dela no payload.
 */
import type { Migration_PreflightAssinaturaRow } from './Migration_PreflightAssinaturaRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Migration_PreflightAssinaturaResponseDados {
registros: Migration_PreflightAssinaturaRow[]
por_tipo: Record<string, number>
}

export type Migration_PreflightAssinaturaResponse = ApiResponse<Migration_PreflightAssinaturaResponseDados>;

registerResponseContract('Migration_PreflightAssinaturaResponse', {
  registros: {
    type: 'array',
    required: true,
    items: {
      zoho_id:    { type: 'string',  required: false },
      tipo:       { type: 'string',  required: false },
      nome:       { type: 'string',  required: false },
      valor:      { type: 'number',  required: false },
      data:       { type: 'string',  required: false },
      ja_migrado: { type: 'boolean', required: false },
      blockers: {
        type: 'array',
        required: false,
        items: {
          code:     { type: 'string',  required: false },
          message:  { type: 'string',  required: false },
          severity: { type: 'string',  required: false },
          entity:   { type: 'string',  required: false },
          zoho_id:  { type: 'string',  required: false },
          label:    { type: 'string',  required: false },
        },
      },
    },
  },
  por_tipo:  { type: 'object',  required: true },
})
